export const AnalyticsConstant = {
  EVENTS: {
    LOGIN: "login",
  },

  EVENT_PARAMS: {
    METHOD: "method",
    USER_ROLE: "user_role",
  },

  USER_PROPERTIES: {
    ROLE: "user_role",
    TENANT_ID: "tenant_id",
    TENANT_NAME: "tenant_name",
    FIRST_ACCESS: "first_access",
  },

  VALUES: {
    LOGIN_METHOD_CREDENTIALS: "credentials",
  },
} as const;
